// extracted by mini-css-extract-plugin
module.exports =  {"divider":"sKuNcLlURbGuL9igtoAe","center":"sHPBc0SFIzItz6zgl4co"};